// Die sechs Ansichten der Projektseite — EINE Quelle fuer Reihenfolge, Text
// und Symbol.
//
// WOFUER: bis hierher stand diese Liste als `VIEWS` in `routes/Project.tsx`
// und trug ihr Symbol als EMOJI ("📋", "📅", "📌", …) — der Typ hiess
// wortwoertlich `icon: string; // emoji per UX spec`. Direkt daneben sassen
// icon-basierte Bedienelemente; das war der auffaelligste Stilbruch der App.
// Hier sind es lucide-Icons.
//
// Die Zuordnung ist bewusst DIESELBE wie in `components/ViewSwitcher.tsx`
// (list -> List, board -> Columns3, calendar -> CalendarDays,
// gantt -> GanttChartSquare), damit beide Ansichts-Umschalter der App eine
// Bildsprache sprechen. `Flag` fuer Meilensteine ist aus
// `components/ProjectAddMenu.tsx` uebernommen (dort schon das Symbol fuer
// „Meilenstein"), `BarChart3` ist neu und nur hier gebraucht.

import {
  BarChart3,
  CalendarDays,
  Columns3,
  Flag,
  GanttChartSquare,
  List,
} from "lucide-preact";
import type { ViewTabItem } from "../../components/ui/ViewTabs";

/**
 * Die ids sind UNVERAENDERT gegenueber der alten `VIEWS`-Konstante
 * ("table" | "timeline" | "kanban" | "calendar" | "milestones" |
 * "analytics"): sie stehen in gespeicherten ViewStates (`_view`-Regel in
 * `project:<id>`) und in gespeicherten Ansichten (`SavedView.view_type`).
 * Eine Umbenennung wuerde jede gespeicherte Ansicht still auf die
 * Standardansicht zuruecksetzen.
 */
export const PROJECT_VIEWS: ViewTabItem[] = [
  { id: "table", label: "Tabelle", icon: List },
  { id: "timeline", label: "Zeitleiste", icon: GanttChartSquare },
  { id: "kanban", label: "Kanban", icon: Columns3 },
  { id: "calendar", label: "Kalender", icon: CalendarDays },
  { id: "milestones", label: "Meilensteine", icon: Flag },
  { id: "analytics", label: "Auswertung", icon: BarChart3 },
];
